import {
  api_react_v1_user_exist_path,
  api_signup_user_path,
  create_user_path,
  unlock_content_path,
} from '@routes';
import { trackNewUser } from '@tracking';
import { LeadType } from '@utils/types';

import request from './request';

export const LEAD_CREATED_EVENT = 'lead_created';

export interface LeadDetails {
  article_title?: string;
  briefing_title?: string;
  forum_post_title?: string;
  homepage_conversion?: boolean;
  newsletter_name?: string;
  org_chart_title?: string;
  project_name?: string;
}

export interface CreateUserParams {
  article_id?: number;
  briefing_guid?: string;
  skip_verify_new_email: boolean;
  newsletter_id?: number;
  newsletter_ids?: number[];
  redirect_to_on_success?: string;
  subscribe_to_all_newsletters?: boolean;
  user: {
    declined_opt_in?: boolean;
    email: string;
    form_location: string;
    lead_type: LeadType;
    opt_in_required?: boolean;
    page: string;
    skip_verify_team_domain?: boolean;
  };
}

export interface CreateUserResponse {
  isNewUser?: boolean;
  location?: string;
  message?: string;
  userId?: number;
}

export interface CreateUserFromUnlockedContentResponse {
  location?: string;
  new_lead?: boolean;
}

export interface CreateUserForSubscribePageParams {
  code?: string;
  declined_opt_in?: boolean;
  dob?: string;
  email: string;
  form_location: string;
  lead_type: LeadType;
  name?: string;
  opt_in_required: boolean;
  page: string;
  turnstile_token?: string;
  referring_article_id?: string;
  signup_for_gift_recipient?: boolean;
}

export interface CreateUserForSubscribePageResponse {
  email: string;
  isNewUser: boolean;
  leadType: LeadType;
  redirectTo: string;
  stripeCustomerId: string;
  userId: number;
}

interface UserExistResponse {
  success: boolean;
}

export const createUser = async (
  params: CreateUserParams,
  leadDetails: LeadDetails
): Promise<CreateUserResponse> => {
  const resp = await request('post', create_user_path(), params);
  if (resp?.isNewUser) {
    trackNewUser(params.user.email, params.user.lead_type, leadDetails);
  }
  return resp;
};

export const createUserByUnlockContent = async (
  params: CreateUserParams,
  leadDetails: LeadDetails
): Promise<CreateUserFromUnlockedContentResponse> => {
  const resp = await request('post', unlock_content_path(), params);
  if (resp?.new_lead) {
    trackNewUser(params.user.email, params.user.lead_type, leadDetails);
  }
  return resp;
};

export const createUserForSubscribePage = async (
  params: CreateUserForSubscribePageParams
): Promise<CreateUserForSubscribePageResponse> => {
  const resp = await request('post', api_signup_user_path(params));
  return resp;
};

export const userExist = async (email: string): Promise<UserExistResponse> => {
  const resp = await request('get', api_react_v1_user_exist_path({ email }));
  return resp;
};
